<template>
  <div>
    <!-- Debug: windowWidth anzeigen -->
    <!-- <pre>{{ windowWidth }}</pre> -->
    <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
      <div class="single container-max page-content mb-5">
        <div class="row position-relative" v-if="showMobile" :key="'mobile'">
          <div class="col-12 order-1 quick-infos-wrapper d-flex align-items-center px-0 px-md-3">
            <div class="quick-infos-wrapper border-radius p-3 p-md-4 position-relative">
              <div class="tag" v-if="tagName">
                <span class="badge bg-danger">{{ tagName }}</span>
              </div>
              <div class="row">
                <div class="col-12 d-flex align-items-center">
                    <h1>{{ currentVariation | itemName }}</h1>
                    <span v-if="isTop5Player()" class="top-interactions-badge h3 ml-2"
                      @mouseover="showTop5Tooltip = true"
                      @mouseleave="showTop5Tooltip = false">
                      <span v-if="showTop5Tooltip" class="custom-tooltip top5-tooltip">Top 5 Community Gerücht</span>
                      🔥
                    </span>
                </div>
                <div class="col-12 col-md-6">
                  <div v-if="position()" class="quick-info mb-3">
                    <i class="fa fa-map-marker"></i>
                    <span>{{ position() }}</span>
                  </div>
                  <div class="quick-info mb-3">
                    <span class="title font-weight-bold">{{ $translate("FanLiebling::Singleitem.fromClub") }}</span>
                    <slot name="from-club-title"></slot>
                  </div>
                  <div class="quick-info mb-3">
                    <span class="title font-weight-bold">Ziel:</span>
                    <slot name="to-club-title"></slot>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="quick-info mb-3" v-if="probability() !== false || progression() !== false">
                    <span class="title font-weight-bold">{{ $translate("FanLiebling::Singleitem.probabilityHeadline") }}</span>
                    <template v-if="probability() !== false">
                      <span v-if="probability() === '?'">{{ probability() }}</span>
                      <span v-else>{{ probability() }}%</span>
                    </template>
                    <i v-if="progression() === 'Steigend'" class="fa fa-arrow-up text-success"></i>
                    <i v-if="progression() === 'Fallend'" class="fa fa-arrow-down text-danger"></i>
                  </div>
                  <div class="quick-info mb-3" v-if="marketValue()">
                    <span class="title font-weight-bold">{{ $translate("FanLiebling::Singleitem.marketValue") }}</span>
                    <span>{{ formattedMarketValue }} €</span>
                  </div>
                </div>
              </div>
              <div>
                  <a href="#support" class="btn btn-outline-primary support-btn font-weight-bold border-radius" v-if="!isClosed()">
                    <template v-if="isSameClub()">
                      {{ $translate("FanLiebling::Singleitem.ButtonSupportStay") }}
                    </template>
                    <template v-else>
                      {{ $translate("FanLiebling::Singleitem.ButtonSupport") }}
                    </template>
                  </a>
                </div>
            </div>
          </div>

          <div class="col-12 order-2 community-insight-section mb-4">
            <h3 class="insight-section-title">Fan Feedback</h3>
            
            <!-- Hinweis bei geschlossenem Gerücht -->
            <div v-if="isClosed()" class="alert alert-info mb-3 text-center">
                <i class="fa fa-lock mr-1"></i>
                Gerücht geschlossen - Abstimmungen sind nicht mehr möglich
            </div>
            
            <!-- Login Info -->
            <div v-if="!isLoggedIn && !isClosed()" class="alert alert-warning mb-2 text-center px-0">                
                <a href="javascript:void(0)" @click="openRegisterModal" class="alert-link small py-2 px-3" style="cursor: pointer;">
                    <i class="fa fa-info-circle mr-1"></i>Fan-Konto erstellen & mitentscheiden
                </a>
            </div>
            
            <!-- Vote & Probability Widgets (nebeneinander) -->
            <div class="row">
                <div class="col-12 col-md-6 mb-3">
                <vote-widget 
                    reference-type="item" 
                    :reference-id="currentVariation.variation.id"
                    :show-title="true"
                    title="Wie findest du dieses Gerücht?"
                    :disabled="isClosed()">
                </vote-widget>
                </div>
                <div class="col-12 col-md-6 mb-3">
                <rumor-probability-widget
                    :variation-id="currentVariation.variation.id"
                    :show-title="true"
                    title="Wie wahrscheinlich ist dieses Gerücht?"
                    :initial-average-probability="averageProbabilityFromProperty()"
                    :initial-count="probabilityCountFromProperty()"
                    :disabled="isClosed()">
                </rumor-probability-widget>
                </div>
            </div>
            
            <!-- Team Impact Widget (volle Breite) -->
            <div class="widget-card widget-full mb-3">
                <team-impact-widget
                reference-type="item"
                :reference-id="currentVariation.variation.id"
                :current-variation="currentVariation"
                :show-title="true"
                :disabled="isClosed()">
                <template v-slot:club-name>
                    <slot name="to-club-title"></slot>
                </template>
                </team-impact-widget>
            </div>
            </div>

          <div class="col-12 order-5 editorial justify-content-between my-5">
            <div>
              <div class="d-flex justify-content-between align-items-start">
                <h2 class="h2 title mb-3" data-testing="item-name" style="display: flex; align-items: center; gap: 10px; flex-wrap: wrap;">
                  <span class="font-weight-bold">{{ currentVariation.texts.name2 }}</span>                  
                </h2>
                <ul class="share menu" id="shareDiv">
                  <li class="share top">
                    <i class="fa fa-share-alt"></i>
                    <ul class="submenu">
                      <li>
                        <a id="share-facebook" class="facebook" href="javascript:void(0);" onclick="share('facebook')"> <i class="fa fa-facebook-official" aria-hidden="true"></i></a>
                      </li>
                      <li>
                        <a id="share-twitter" class="twitter" href="javascript:void(0);" onclick="share('twitter')"> <i class="fa fa-twitter" aria-hidden="true"></i></a>
                      </li>
                      <li>
                        <a id="share-whatsapp" class="whatsapp" href="javascript:void(0);" onclick="share('whatsapp')"> <i class="fa fa-whatsapp" aria-hidden="true"></i> </a>
                      </li>
                      <li>
                        <a id="share-email" class="mail" href="javascript:void(0);" onclick="share('email')"> <i class="fa fa-envelope-o" aria-hidden="true"></i></a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>

              <div v-if="editorialDate()" class="editorialDate mb-3" v-html="editorialDate()"></div>
              <div v-if="editorialText()" class="editorialText mb-0" v-html="removeIsPastedId(editorialText())"></div>
            </div>
          </div>

          <div class="col-12 xselling mb-4 order-7" id="competition" v-if="currentVariation.crossSelling">
            <div class="col-12 px-0">
              <p class="h3 font-weight-bold">{{ $translate("FanLiebling::Singleitem.SimilarHeadline") }}{{ currentVariation | itemName }}</p>
              <hr />
            </div>
            <slot name="cross-selling-similar"></slot>
          </div>

          <div class="col-12 order-6 support-box border-radius p-3 p-md-4 position-relative mb-4" id="support">
            <div v-if="isWishListEnabled" class="fl-wishlist">
              <add-to-wish-list :variation-id="currentVariation.variation.id"></add-to-wish-list>
            </div>
            <div class="support-wrapper d-flex justify-content-between mb-3" v-if="!isClosed()">
              <div>
                <template v-if="isSameClub()">
                  <span class="font-weight-bold h3 d-block mb-3">{{ $translate("FanLiebling::Singleitem.supportStayHeadline") }}</span>
                </template>
                <template v-else>
                  <span class="font-weight-bold h3 d-block mb-3">{{ $translate("FanLiebling::Singleitem.supportHeadline") }}</span>
                </template>
                <span class="subheadline">{{ $translate("FanLiebling::Singleitem.supportSubHeadline") }}</span>
              </div>
            </div>

            <slot name="before-price"></slot>
            <slot name="after-price"></slot>

            <div class="mb-3">
              <div class="w-100">
                <slot name="before-add-to-basket"></slot>
              </div>

              <div class="mt-3">
                <div v-if="isClosed()" class="mb-5">
                  <p class="font-weight-bold mb-0">
                    {{ $translate("FanLiebling::Singleitem.closedHeadline") }}
                  </p>
                  <p>
                    {{ $translate("FanLiebling::Singleitem.closedText") }}
                  </p>
                  <div v-if="isClosedMessage()">
                    <p class="text-success h2" v-html="isClosedMessage()"></p>
                  </div>
                </div>
                <div v-else class="add-to-basket">
                  <div class="d-flex properties-wrapper">
                    <order-property-list></order-property-list>
                    <span class="club-title">(<slot name="to-club-title"></slot>)</span>
                  </div>
                  <add-to-basket
                    :variation-id="currentVariation.variation.id"
                    :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                    :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                    :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                    :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                    :maximum-quantity="
                      !!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null
                    "
                    :order-properties="
                      currentVariation.properties.filter(function(prop) {
                        return prop.property.isOderProperty;
                      })
                    "
                    :has-order-properties="currentVariation.hasOrderProperties"
                    :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                    :use-large-scale="false"
                    :show-quantity="true"
                    :item-url="currentVariation | itemURL"
                    :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                    :has-price="currentVariation | hasItemDefaultPrice"
                  >
                  </add-to-basket>
                </div>
              </div>

              <div v-if="currentVariation.filter.isSalable && variationGroupedProperties.length && !isClosed()"></div>

              <p v-if="sales() && !isClosed()" class="sales mb-3">
                <span v-if="sales() >= 5 && sales() < 10">
                  Dein Fanliebling hat fast 10 Unterstützer erreicht!
                </span>
                <span v-else-if="sales() >= 10 && sales() < 20">
                  Dein Fanliebling hat mehr als 10 Unterstützer erreicht!
                </span>
                <span v-else-if="sales() >= 20 && sales() <= 30">
                  Dein Fanliebling begeistert bereits über 20 Unterstützer!
                </span>
                <span v-else-if="sales() > 30">
                  Dein Fanliebling hat schon über {{ sales() }} Unterstützer begeistert!
                </span>
              </p>

              <div class="w-100 pp-button">
                <slot name="after-add-to-basket"></slot>
              </div>

              <!-- Fan Feedback Section (Mobile) -->              
            </div>

            <!-- ./ITEM DETAIL -->

            <slot name="additional-content-after-add-to-basket"></slot>

            <slot name="additional-content-after-vat"></slot>
          </div>

          <div class="col-12 order-5 mb-3" v-if="!isClosed()">
            <div class="how-it-works p-3 border-radius">
              <p class="headline mb-1">Wie funktioniert es?</p>
              <ol class="pl-3 mb-0">
                <li>
                  Du unterstützt den Wechsel (od. Verbleib) deines Fanliebling&nbsp;mit deinem gewählten Beitrag
                </li>
                <li>
                  <span v-html="$translate('FanLiebling::Singleitem.HowToIcon1Text')"></span>
                </li>
                <li>
                  a)&nbsp;<span v-html="$translate('FanLiebling::Singleitem.HowToIcon3Text')"></span><br />
                  b)&nbsp;<span v-html="$translate('FanLiebling::Singleitem.HowToIcon4Text')"></span>
                </li>
              </ol>
            </div>
          </div>

          <div class="col-12 col-sm-6 order-3">
            <div class="player-infos border-radius p-md-4 mb-4">
              <p class="font-weight-bold h3">
                {{ $translate("FanLiebling::Singleitem.playerHeadline") }}
              </p>
              <hr />
              <span class="mt-3 w-100" v-html="currentVariation.texts.description"></span>
            </div>
          </div>

          <div class="col-12 col-sm-6 order-4" v-if="getSofaScoreWidget()">
            <div class="player-infos border-radius p-md-4 mb-4">
              <p class="font-weight-bold h3">{{ $translate("FanLiebling::Singleitem.playerTechnicalHeadline") }}</p>
              <hr />
              <iframe-consent-wrapper
                :content="getSofaScoreWidget()"
                :title="$translate('FanLiebling::Homepage.section3TransferCheckIframeTitle')"
                :message="$translate('FanLiebling::Homepage.section3TransferCheckIframeMessage')"
                :button-text="$translate('FanLiebling::Homepage.section3TransferCheckIframeButton')"
                storage-key="sofascore_consent_global">
              </iframe-consent-wrapper>
            </div>
          </div>

          <div class="col-12 col-sm-6 order-4" v-else-if="currentVariation.texts.technicalData && currentVariation.texts.technicalData.trim() !== ''">
            <div class="player-infos border-radius p-md-4 mb-4">
              <p class="font-weight-bold h3">{{ $translate("FanLiebling::Singleitem.playerTechnicalHeadline") }}</p>
              <hr />
              <div class="player-infos mt-3" v-html="currentVariation.texts.technicalData"></div>
            </div>
          </div>
          <div class="col-12 col-sm-6 order-4" v-else>
            <div class="player-infos border-radius p-md-4 mb-4">
              <div class="d-flex mb-3 align-items-center fromClub">
                <span class="font-weight-bold h3">
                  {{ $translate("FanLiebling::Singleitem.fromClub") }}
                  <span> <slot name="from-club-title"></slot></span>
                </span>
              </div>
              <div class="fromClub">
                <slot name="from-club-description"></slot>
              </div>
            </div>
          </div>

          <div class="col-12 order-8 mb-4" v-if="!isClosed()">
            <feedback-container
              class="fl-discuss"
              :options="{ allowFeedbacksOnlyIfPurchased: false, allowNoRatingFeedback: true, feedbacksPerPage: 10, numberOfFeedbacks: 1, timestampVisibility: true, allowGuestFeedbacks: true }"
              classes=""
              styles=""
            >
            </feedback-container>
          </div>

          <div class="col-12 col-sm-6 order-9 mb-4">
            <slot name="cross-selling-hot"></slot>
          </div>
          <div class="col-12 col-sm-6 order-10 mb-4">
            <slot name="cross-selling-tag-new"></slot>
          </div>
        </div>
        <!-- end windowWidth <= 1024 -->

        <div class="row position-relative" v-else :key="'desktop'">
          <div class="left-col col-lg-8 mt-4">
            <!-- Quick Infos Wrapper -->
            <div class="quick-infos-wrapper border-radius p-3 p-md-4 position-relative mb-4">
              <div class="tag" v-if="tagName">
                <span class="badge bg-danger">{{ tagName }}</span>
              </div>
              <div class="row">
                <div class="col-12 d-flex align-items-center">
                    <h1>{{ currentVariation | itemName }}</h1>
                    <span v-if="isTop5Player()" class="top-interactions-badge h3 ml-2"
                      @mouseover="showTop5Tooltip = true"
                      @mouseleave="showTop5Tooltip = false">
                      <span v-if="showTop5Tooltip" class="custom-tooltip top5-tooltip">Top 5 Community Gerücht</span>
                      🔥
                    </span>
                </div>
                <div class="col-12 col-md-6">
                  <div v-if="position()" class="quick-info mb-3">
                    <i class="fa fa-map-marker"></i>
                    <span>{{ position() }}</span>
                  </div>
                  <div class="quick-info mb-3">
                    <span class="title font-weight-bold">{{ $translate("FanLiebling::Singleitem.fromClub") }}</span>
                    <slot name="from-club-title"></slot>
                  </div>
                  <div class="quick-info mb-3">
                    <span class="title font-weight-bold">Ziel:</span>
                    <slot name="to-club-title"></slot>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="quick-info mb-3" v-if="probability() !== false || progression() !== false">
                    <span class="title font-weight-bold">{{ $translate("FanLiebling::Singleitem.probabilityHeadline") }}</span>
                    <template v-if="probability() !== false">
                      <span v-if="probability() === '?'">{{ probability() }}</span>
                      <span v-else>{{ probability() }}%</span>
                    </template>
                    <i v-if="progression() === 'Steigend'" class="fa fa-arrow-up text-success"></i>
                    <i v-if="progression() === 'Fallend'" class="fa fa-arrow-down text-danger"></i>
                  </div>
                  <div class="quick-info mb-3" v-if="marketValue()">
                    <span class="title font-weight-bold">{{ $translate("FanLiebling::Singleitem.marketValue") }}</span>
                    <span>{{ formattedMarketValue }} €</span>
                  </div>
                </div>
              </div>
              <div>
                  <a href="#support" class="btn btn-outline-primary support-btn font-weight-bold border-radius" v-if="!isClosed()">
                    <template v-if="isSameClub()">
                      {{ $translate("FanLiebling::Singleitem.ButtonSupportStay") }}
                    </template>
                    <template v-else>
                      {{ $translate("FanLiebling::Singleitem.ButtonSupport") }}
                    </template>
                  </a>
                </div>
            </div>

            <!-- Fan Feedback Section -->
            <div class="community-insight-section mb-4">
              <h3 class="insight-section-title">Fan Feedback</h3>
              
              <!-- Hinweis bei geschlossenem Gerücht -->
              <div v-if="isClosed()" class="alert alert-info mb-3 text-center">
                <i class="fa fa-lock mr-1"></i>
                Gerücht geschlossen - Abstimmungen sind nicht mehr möglich
              </div>
              
              <!-- Login Info -->
              <div v-if="!isLoggedIn && !isClosed()" class="alert alert-warning mb-2 text-center px-0">                
                <a href="javascript:void(0)" @click="openRegisterModal" class="alert-link small py-2 px-3" style="cursor: pointer;">
                    <i class="fa fa-info-circle mr-1"></i>Fan-Konto erstellen & mitentscheiden
                </a>
              </div>
              
              <!-- Vote & Probability Widgets (nebeneinander) -->
              <div class="widgets-row mb-3">
                <div class="widget-card widget-half d-flex align-items-center justify-content-center">
                  <vote-widget 
                    reference-type="item" 
                    :reference-id="currentVariation.variation.id"
                    :show-title="false"
                    :disabled="isClosed()">
                  </vote-widget>
                </div>
                
                <div class="widget-card widget-half">
                  <rumor-probability-widget
                    :variation-id="currentVariation.variation.id"
                    :show-title="false"
                    :initial-average-probability="averageProbabilityFromProperty()"
                    :initial-count="probabilityCountFromProperty()"
                    :disabled="isClosed()">
                  </rumor-probability-widget>
                </div>
              </div>
              
              <!-- Team Impact Widget (volle Breite) -->
              <div class="widget-card widget-full">
                <team-impact-widget
                  reference-type="item"
                  :reference-id="currentVariation.variation.id"
                  :current-variation="currentVariation"
                  :show-title="true"
                  :disabled="isClosed()">
                  <template v-slot:club-name>
                    <slot name="to-club-title"></slot>
                  </template>
                </team-impact-widget>
              </div>
            </div>

            <div class="editorial justify-content-between my-5">
              <div>
                <div class="d-flex justify-content-between align-items-start">
                  <h2 class="h2 title mb-3" data-testing="item-name" style="display: flex; align-items: center; gap: 10px; flex-wrap: wrap;">
                    <span class="font-weight-bold">{{ currentVariation.texts.name2 }}</span>                    
                  </h2>
                  <ul class="share menu" id="shareDiv">
                    <li class="share top">
                      <i class="fa fa-share-alt"></i>
                      <ul class="submenu">
                        <li>
                          <a id="share-facebook" class="facebook" href="javascript:void(0);" onclick="share('facebook')"> <i class="fa fa-facebook-official" aria-hidden="true"></i></a>
                        </li>
                        <li>
                          <a id="share-twitter" class="twitter" href="javascript:void(0);" onclick="share('twitter')"> <i class="fa fa-twitter" aria-hidden="true"></i></a>
                        </li>
                        <li>
                          <a id="share-whatsapp" class="whatsapp" href="javascript:void(0);" onclick="share('whatsapp')"> <i class="fa fa-whatsapp" aria-hidden="true"></i> </a>
                        </li>
                        <li>
                          <a id="share-email" class="mail" href="javascript:void(0);" onclick="share('email')"> <i class="fa fa-envelope-o" aria-hidden="true"></i></a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>

                <div v-if="editorialDate()" class="editorialDate mb-3" v-html="editorialDate()"></div>
                <div v-if="editorialText()" class="editorialText mb-0" v-html="removeIsPastedId(editorialText())"></div>
              </div>
            </div>

            <div class="support-box border-radius p-3 p-md-4 position-relative mb-4" id="support">
              <div v-if="isWishListEnabled" class="fl-wishlist">
                <add-to-wish-list :variation-id="currentVariation.variation.id"></add-to-wish-list>
              </div>
              
              <!-- Support Header -->
              <div class="support-header mb-4" v-if="!isClosed()">
                <h3 class="support-title" v-if="isSameClub()">
                  {{ $translate("FanLiebling::Singleitem.supportStayHeadline") }}
                </h3>
                <h3 class="support-title" v-else>
                  {{ $translate("FanLiebling::Singleitem.supportHeadline") }}
                </h3>
                <p class="support-subtitle">{{ $translate("FanLiebling::Singleitem.supportSubHeadline") }}</p>
              </div>

              <slot name="before-price"></slot>
              <slot name="after-price"></slot>

              <div class="mb-0">
                <div class="w-100">
                  <slot name="before-add-to-basket"></slot>
                </div>

                <div class="d-flex properties-wrapper" v-if="!isClosed()">
                  <order-property-list></order-property-list>
                  <span class="club-title">(<slot name="to-club-title"></slot>)</span>
                </div>

                <div class="mt-3">
                  <div v-if="isClosed()" class="mb-5">
                    <p class="font-weight-bold mb-0">
                      {{ $translate("FanLiebling::Singleitem.closedHeadline") }}
                    </p>
                    <p>
                      {{ $translate("FanLiebling::Singleitem.closedText") }}
                    </p>
                    <div v-if="isClosedMessage()">
                      <p class="text-success h2" v-html="isClosedMessage()"></p>
                    </div>
                  </div>
                  <div v-else class="add-to-basket">
                    <add-to-basket
                      :variation-id="currentVariation.variation.id"
                      :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                      :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                      :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                      :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                      :maximum-quantity="
                        !!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null
                      "
                      :order-properties="
                        currentVariation.properties.filter(function(prop) {
                          return prop.property.isOderProperty;
                        })
                      "
                      :has-order-properties="currentVariation.hasOrderProperties"
                      :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                      :use-large-scale="false"
                      :show-quantity="true"
                      :item-url="currentVariation | itemURL"
                      :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                      :has-price="currentVariation | hasItemDefaultPrice"
                    >
                    </add-to-basket>
                  </div>
                </div>

                <div v-if="currentVariation.filter.isSalable && variationGroupedProperties.length && !isClosed()"></div>

                <p v-if="sales() && !isClosed()" class="sales">
                  <span class="mb-3" v-if="sales() >= 5 && sales() < 10">
                    Dein Fanliebling hat fast 10 Unterstützer erreicht!
                  </span>
                  <span class="mb-3" v-else-if="sales() >= 10 && sales() < 20">
                    Dein Fanliebling hat mehr als 10 Unterstützer erreicht!
                  </span>
                  <span class="mb-3" v-else-if="sales() >= 20 && sales() <= 30">
                    Dein Fanliebling begeistert bereits über 20 Unterstützer!
                  </span>
                  <span class="mb-3" v-else-if="sales() > 30">
                    Dein Fanliebling hat schon über {{ sales() }} Unterstützer begeistert!
                  </span>
                </p>

                <div class="w-100 pp-button">
                  <slot name="after-add-to-basket"></slot>
                </div>
              </div>

              <!-- ./ITEM DETAIL -->

              <slot name="additional-content-after-add-to-basket"></slot>

              <slot name="additional-content-after-vat"></slot>
            </div>

            <div class="how-it-works border-radius p-2 p-md-4 mb-4" v-if="!isClosed()">
              <p class="headline mb-1">Wie funktioniert es?</p>
              <ol class="pl-3 mb-0">
                <li>
                  Du unterstützt den Wechsel deines Fanliebling&nbsp;mit deinem gewählten Beitrag
                </li>
                <li>
                  <span v-html="$translate('FanLiebling::Singleitem.HowToIcon1Text')"></span>
                </li>
                <li>
                  a)&nbsp;<span v-html="$translate('FanLiebling::Singleitem.HowToIcon3Text')"></span><br />
                  b)&nbsp;<span v-html="$translate('FanLiebling::Singleitem.HowToIcon4Text')"></span>
                </li>
              </ol>
            </div>

            <feedback-container
              class="fl-discuss"
              :options="{ allowFeedbacksOnlyIfPurchased: false, allowNoRatingFeedback: true, feedbacksPerPage: 10, numberOfFeedbacks: 1, timestampVisibility: true, allowGuestFeedbacks: true }"
              classes=""
              styles=""
            >
            </feedback-container>

            <div class="fromClub my-5">
              <p class="font-weight-bold h3">
                {{ $translate("FanLiebling::Singleitem.fromClub") }}<span><slot name="from-club-title"></slot></span>
              </p>
              <div class="col-12 px-0">
                <slot name="from-club-description"></slot>
              </div>
            </div>
          </div>
          <!-- end left -->
          <div class="right-col col-lg-4 mt-4">
            <div class="player-infos mb-4">
              <p class="font-weight-bold h3">
                {{ $translate("FanLiebling::Singleitem.playerHeadline") }}
              </p>
              <hr />
              <span class="mt-3 w-100" v-html="currentVariation.texts.description"></span>
            </div>

            <div class="player-infos mb-4" v-if="getSofaScoreWidget()">
              <p class="font-weight-bold h3">{{ $translate("FanLiebling::Singleitem.playerTechnicalHeadline") }}</p>
              <hr />
              <iframe-consent-wrapper
                :content="getSofaScoreWidget()"
                :title="$translate('FanLiebling::Homepage.section3TransferCheckIframeTitle')"
                :message="$translate('FanLiebling::Homepage.section3TransferCheckIframeMessage')"
                :button-text="$translate('FanLiebling::Homepage.section3TransferCheckIframeButton')"
                storage-key="sofascore_consent_global">
              </iframe-consent-wrapper>
            </div>
            
            <div class="player-infos mb-4" v-else-if="currentVariation.texts.technicalData && currentVariation.texts.technicalData.trim() !== ''">
              <p class="font-weight-bold h3">{{ $translate("FanLiebling::Singleitem.playerTechnicalHeadline") }}</p>
              <hr />
              <div class="player-infos mt-3" v-html="currentVariation.texts.technicalData"></div>
            </div>

            <div>
                <slot name="cross-selling-hot"></slot>
                <slot name="cross-selling-tag-new"></slot>              
            </div>
            <div class="xselling mb-4 pt-4" id="competition" v-if="currentVariation.crossSelling">
              <div class="col-12 px-0">
                <p class="h3 font-weight-bold">{{ $translate("FanLiebling::Singleitem.SimilarHeadline") }}{{ currentVariation | itemName }}</p>
                <hr />
              </div>
              <slot name="cross-selling-similar"></slot>
            </div>
          </div>
          <!-- end right -->
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { get } from "../../helper/get";
import { isNullOrUndefined } from "../../helper/utils";

export default {
  name: "single-item",

  props: {
    pleaseSelectOptionVariationId: {
      type: Number,
      default: 0,
    },
    initPleaseSelectOption: {
      type: Boolean,
      default: false,
    },
    showNetPrices: {
      type: Boolean,
      default: false,
    },
    isWishListEnabled: {
      type: Boolean,
      default: false,
    },
    itemId: {
      type: Number,
      required: true,
    },
    afterKey: Object,
  },

  jsonDataFields: ["itemData", "attributesData", "variations"],

  provide() {
    return {
      itemId: this.$props.itemId,
    };
  },

  data() {
    return {
      maxValue: 1,
      currentValue: 0,
      showTooltip: false,
      showTop5Tooltip: false,
      targetValue: 0,
      progressWidth: 0,
      windowWidthValue: 1024,
      isClient: false,
      feedbackObserver: null, // MutationObserver für Feedback-Tracking
    };
  },

  computed: {
    formattedMarketValue() {
      const value = this.marketValue();
      const parsedValue = parseFloat(value);

      if (isNaN(parsedValue)) return value; // Fallback bei ungültigem Wert

      // Formatierung mit Tausendertrennpunkten
      return parsedValue.toLocaleString("de-DE");
    },

    progressClass() {
      if (this.progressWidth >= 75) return "gold";
      if (this.progressWidth >= 50) return "silver";
      if (this.progressWidth >= 25) return "kupfer";
      return "";
    },
    progressLabel() {
      if (this.progressWidth >= 75) return "Weltklasse";
      if (this.progressWidth >= 50) return "Profi";
      if (this.progressWidth >= 25) return "Amateur";
      return "Anfänger";
    },
    percentToNextMilestone() {
      let remaining = 0;
      if (this.progressWidth < 25) remaining = 25 - this.progressWidth;
      else if (this.progressWidth < 50) remaining = 50 - this.progressWidth;
      else if (this.progressWidth < 75) remaining = 75 - this.progressWidth;
      else if (this.progressWidth < 100) remaining = 100 - this.progressWidth;
      return parseFloat(remaining.toFixed(2)); // Rundet auf 2 Nachkommastellen
    },
    nextMilestoneLabel() {
      if (this.progressWidth < 25) return "Amateur";
      if (this.progressWidth < 50) return "Profi";
      if (this.progressWidth < 75) return "Weltklasse";
      if (this.progressWidth < 100) return "Legende";
      return ""; // Kein nächster Meilenstein mehr
    },

    itemConfig() {
      return App.config.item.itemData;
    },

    isDescriptionTabActive() {
      return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all")) && !!this.currentVariation.texts.description.length;
    },

    tagName() {
      const tag = this.currentVariation.tags?.[0];
      return tag?.id === 1 ? tag?.names?.name || null : null;
    },

    isManufacturerTabShown() {
      return (
        this.currentVariation.item.manufacturer.url !== "" ||
        this.currentVariation.item.manufacturer.street !== "" ||
        this.currentVariation.item.manufacturer.houseNo !== "" ||
        this.currentVariation.item.manufacturer.postcode !== "" ||
        this.currentVariation.item.manufacturer.town !== "" ||
        this.currentVariation.item.manufacturer.countryId !== 0 ||
        this.currentVariation.item.manufacturer.phoneNumber !== "" ||
        this.currentVariation.item.manufacturer.faxNumber !== "" ||
        this.currentVariation.item.manufacturer.email !== "" ||
        this.currentVariation.item.manufacturer.legalName !== "" ||
        this.currentVariation.item.manufacturer.contactUrl !== "" ||
        this.currentVariation.item.manufacturer.name !== ""
      );
    },
    isEuResponsibleTabShown() {
      return (
        this.currentVariation.item.manufacturer.responsibleEmail !== "" ||
        this.currentVariation.item.manufacturer.responsibleHouseNo !== "" ||
        this.currentVariation.item.manufacturer.responsibleName !== "" ||
        this.currentVariation.item.manufacturer.responsiblePhoneNo !== "" ||
        this.currentVariation.item.manufacturer.responsiblePostCode !== "" ||
        this.currentVariation.item.manufacturer.responsibleStreet !== "" ||
        this.currentVariation.item.manufacturer.responsibleTown !== "" ||
        this.currentVariation.item.manufacturer.responsibleContactUrl !== "" ||
        this.currentVariation.item.manufacturer.responsibleCountry !== 0
      );
    },

    isRecommendedPriceActive() {
      return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
    },

    isShortDescriptionActive() {
      return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
    },

    hasShippingCostsCategoryId() {
      return App.config.global.shippingCostsCategoryId > 0;
    },

    isTechnicalDataTabActive() {
      return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all")) && !!this.currentVariation.texts.technicalData.length;
    },

    variationGroupedProperties() {
      return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
    },

    variationMissingProperties() {
      return this.$store.getters[`${this.itemId}/variationMissingProperties`];
    },

    currentVariation() {
      return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
    },

    isVariationSelected() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
    },

    attributes() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
    },

    units() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
    },

    isItemSet() {
      return this.$store.state.items.isItemSet;
    },

    windowWidth() {
      return this.windowWidthValue;
    },
    showMobile() {
      return this.isClient ? this.windowWidth <= 1024 : false;
    },
    
    // Player Name (aus texts.name2)
    playerName() {
      return this.currentVariation?.texts?.name2 || '';
    },
    
    // Club Name (aus Property ID 60 - to-club)
    clubName() {
      try {
        const properties = this.currentVariation?.variationProperties || [];
        for (const propertyGroup of properties) {
          for (const prop of propertyGroup.properties || []) {
            if (prop.id === 60) {
              // Property 60 ist "to-club"
              return prop.names?.name || '';
            }
          }
        }
      } catch (e) {
        console.warn('Could not extract club name:', e);
      }
      return '';
    },
    
    ...mapState({
    }),

    ...mapGetters(["isLoggedIn"]),
  },

  created() {
    if (typeof window !== "undefined") {
      this.windowWidthValue = window.innerWidth;
    }
    this.$store.dispatch("initVariation", this.itemData);
    this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
  },

  mounted() {
    if (typeof window !== "undefined") {
      this.windowWidthValue = window.innerWidth;
      this.isClient = true;
      window.addEventListener("resize", this.updateWindowWidth);
    }
    // Werte holen und sicherstellen, dass sie numerisch sind
    const marketValueRaw = this.marketValue();
    const remainingStockRaw = this.remainingStock();

    const marketValueInt = parseInt(marketValueRaw.replace(/\D/g, ""), 10) || 1;
    const remainingStock = parseInt(remainingStockRaw.replace(/\D/g, ""), 10) || 0;

    // Zielwert basierend auf dem Marktwert festlegen
    let targetValue;
    if (marketValueInt <= 2000000) {
      targetValue = 800000;
    } else if (marketValueInt <= 10000000) {
      targetValue = 1500000;
    } else {
      targetValue = 5000000;
    }

    // Fortschrittsbreite berechnen
    const consumedValue = marketValueInt - remainingStock;
    this.progressWidth = ((consumedValue / (marketValueInt - targetValue)) * 100).toFixed(2);

    // Setze windowWidth initial korrekt!
    if (typeof window !== "undefined") {
      this.windowWidthValue = window.innerWidth;
    }
    // Debug: windowWidth anzeigen
    // console.log("mounted windowWidth", this.windowWidth);

    this.$nextTick(() => {
      this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
        itemId: this.itemId,
        attributes: this.attributesData,
        variations: this.variations,
        initialVariationId: this.currentVariation.variation.id,
        isPleaseSelectOption: this.initPleaseSelectOption,
        afterKey: this.afterKey,
      });

      if (this.isItemSet) {
        this.$store.dispatch("initSetComponents", this.itemData);
      }
    });

    document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
    
    // ===== FEEDBACK ACTIVITY TRACKING =====
    // Deaktiviert wegen Backend-Fehler - muss erst deployed werden
    // this.initFeedbackTracking();
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.updateWindowWidth);
    }
    
    // Cleanup: Entferne MutationObserver
    if (this.feedbackObserver) {
      this.feedbackObserver.disconnect();
    }
  },
  methods: {
    /**
     * Initialisiert das Tracking von Feedback-Aktivitäten
     */
    initFeedbackTracking() {
      if (typeof window === "undefined") return;
      
      // Warte bis DOM vollständig geladen ist
      this.$nextTick(() => {
        setTimeout(() => {
          const feedbackContainers = document.querySelectorAll('.feedback-container.fl-discuss');
          
          feedbackContainers.forEach(container => {
            // 1. Primär: Direkter Click-Listener auf "Beitrag einreichen" Button
            const submitButton = container.querySelector('.createFeedback button.btn-primary.btn-appearance');
            
            if (submitButton) {
              submitButton.addEventListener('click', () => {
                // Warte kurz, damit das Feedback gespeichert wird
                setTimeout(() => {
                  console.log('Feedback-Button geklickt, logge Aktivität...');
                  this.logFeedbackActivity();
                }, 500);
              });
              console.log('Feedback tracking aktiviert für Submit-Button');
            }
            
            // 2. Fallback: MutationObserver für neu erscheinende Feedbacks in der Liste
            const feedbackLists = container.querySelectorAll('.feedback-list');
            if (feedbackLists.length > 0) {
              this.feedbackObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                  // Prüfe ob neue Feedback-Elemente hinzugefügt wurden
                  if (mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach((node) => {
                      if (node.nodeType === 1) { // Element node
                        console.log('Neues Feedback in Liste erkannt, logge Aktivität...');
                        this.logFeedbackActivity();
                      }
                    });
                  }
                });
              });
              
              // Beobachte alle feedback-list Elemente
              feedbackLists.forEach(list => {
                this.feedbackObserver.observe(list, {
                  childList: true,
                  subtree: false
                });
              });
              console.log('Feedback MutationObserver aktiviert für feedback-list');
            }
          });
        }, 2000); // Warte 2s bis feedback-container geladen ist
      });
    },
    
    /**
     * Loggt eine Feedback-Aktivität
     */
    logFeedbackActivity() {
      if (!this.currentVariation || !this.currentVariation.variation) {
        return;
      }
      
      const ApiService = require("../../services/ApiService").default;
      
      ApiService.post("/rest/fanliebling/feedback-activity", {
        variationId: this.currentVariation.variation.id,
        feedbackType: "comment"
      }, {
        supressNotifications: true
      })
        .done((response) => {
          console.log('Feedback activity logged:', response);
        })
        .fail((error) => {
          console.warn('Failed to log feedback activity:', error);
        });
    },
    
    isSameClub() {
      // Prüfe, ob die Properties mit ID 60 und 61 identisch sind
      let club60 = null;
      let club61 = null;
      if (this.currentVariation?.variationProperties) {
        for (let property of this.currentVariation.variationProperties) {
          if (property.properties) {
            const prop60 = property.properties.find((prop) => prop.id === 60);
            const prop61 = property.properties.find((prop) => prop.id === 61);
            if (prop60 && prop60.values) club60 = prop60.values.value;
            if (prop61 && prop61.values) club61 = prop61.values.value;
          }
        }
      }
      return club60 !== null && club61 !== null && club60 === club61;
    },
    probability() {
      if (this.currentVariation?.variationProperties) {
        for (let property of this.currentVariation.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 63);
            if (result?.values) {
              const value = result.values.value;

              // Prüfen, ob der Wert "?" ist
              if (value === "?") {
                return value; // "?" zurückgeben
              }

              // String in Integer umwandeln
              const parsedValue = Number(value);
              if (!isNaN(parsedValue)) {
                return parsedValue; // Gültige Zahl zurückgeben
              }
            }
          }
        }
      }
      return false; // Fallback, falls keine gültigen Werte gefunden werden
    },

    progression() {
      if (this.currentVariation?.variationProperties) {
        for (let property of this.currentVariation.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 64);
            if (result?.values) {
              const value = result.values.value;

              // Rückgabe der entsprechenden Werte
              if (value === "-1") {
                return "Fallend";
              } else if (value === "1") {
                return "Steigend";
              }

              return false; // Rückgabe false für nicht erkannte Werte
            }
          }
        }
      }
      return false; // Rückgabe false, falls keine Werte gefunden werden
    },

    editorialText() {
      if (this.currentVariation?.variationProperties) {
        for (let property of this.currentVariation.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 79);
            if (result?.values) {
              return result.values.value || false;
            }
          }
        }
      }
      return false;
    },

    editorialDate() {
      if (this.currentVariation?.variationProperties) {
        for (let property of this.currentVariation.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 80);
            if (result?.values) {
              return result.values.value || false;
            }
          }
        }
      }
      return false;
    },

    position() {
      if (this.currentVariation?.variationProperties) {
        for (let property of this.currentVariation.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 73);
            if (result?.values) {
              return result.values.value || false;
            }
          }
        }
      }
      return false;
    },

    sales() {
      if (this.currentVariation?.variationProperties) {
        for (let property of this.currentVariation.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 77);
            if (result?.values) {
              const value = parseInt(result.values.value, 10);
              return isNaN(value) ? false : value;
            }
          }
        }
      }
      return false;
    },

    isClosed() {
      if (this.currentVariation?.variationProperties) {
        for (let property of this.currentVariation.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 62);
            if (result?.values && typeof result.values.value === "string" && result.values.value.trim() !== "") {
              return true;
            }
          }
        }
      }
      return false;
    },

    isClosedMessage() {
      if (this.currentVariation?.variationProperties) {
        for (let property of this.currentVariation.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 78);
            if (result?.values) {
              return result.values.value || false;
            }
          }
        }
      }
      return false;
    },

    marketValue() {
      if (this.currentVariation?.variationProperties) {
        for (let property of this.currentVariation.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 58);
            if (result?.values) {
              return result.values.value || "unbekannt";
            }
          }
        }
      }
      return "unbekannt";
    },

    remainingStock() {
      if (this.currentVariation?.variationProperties) {
        for (let property of this.currentVariation.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 74);
            if (result?.values) {
              return result.values.value || "0";
            }
          }
        }
      }
      return "0";
    },

    getDataField(field) {
      return get(this.currentVariation, field);
    },

    getFilteredDataField(field, filter) {
      if (!isNullOrUndefined(this.$options.filters[filter])) {
        return this.$options.filters[filter](this.getDataField(field));
      }

      return this.getDataField(field);
    },

    // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
    hydrateChildren(nodes) {
      nodes.forEach((component) => {
        if (component.$options.name === "lazy-hydrate") {
          component.hydrate();
        } else if (component.$children.length) {
          this.hydrateChildren(component.$children);
        }
      });
    },

    updateWindowWidth() {
      if (typeof window !== "undefined") {
        const width = window.innerWidth;
        if (this.windowWidthValue !== width) {
          this.windowWidthValue = width;
          this.windowWidthUpdateKey++; // Dummy erhöhen
          this.$forceUpdate(); // Vue zwingen, das Template neu zu rendern
        }
      }
    },
    removeIsPastedId(text) {
      if (!text) return "";
      // Entfernt id="isPasted" aus allen Tags
      return text.replace(/\s*id\s*=\s*["']isPasted["']/gi, "");
    },

    hasProperty82() {
      if (this.currentVariation?.variationProperties) {
        for (let property of this.currentVariation.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 82);
            if (result) {
              return true; // Eigenschaft ID 82 ist vorhanden
            }
          }
        }
      }
      return false; // Eigenschaft ID 82 ist nicht vorhanden
    },
    
    /**
     * Prüft ob der aktuelle Spieler in den Top 5 Interaktionen ist
     * @returns {boolean}
     */
    isTop5Player() {
      if (this.currentVariation?.variationProperties) {
        for (let property of this.currentVariation.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 94 && prop.values && prop.values.value === "1");
            if (result) {
              return true;
            }
          }
        }
      }
      return false;
    },
    
    /**
     * Öffnet das Registrierungs-Modal
     */
    openRegisterModal(event) {
      // Verhindere Default-Link-Behavior und Scrollen
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      
      // SSR-Check: Nur im Browser ausführen
      if (typeof window === "undefined" || typeof document === "undefined") {
        return;
      }

      // Speichere die aktuelle Scroll-Position
      const scrollY = window.scrollY;

      // Lade das Modal via Store (wenn noch nicht geladen)
      if (this.$store && this.$store.dispatch) {
        this.$store.dispatch('loadComponent', 'login-modal');
      }
      
      // Warte auf die geladene Komponente, dann öffne das Modal
      const checkAndOpenModal = () => {
        const modalElement = document.getElementById('login');
        if (modalElement && window.$) {
          // Prüfe, ob die Login-Komponente geladen wurde
          const isComponentLoaded = this.$store && this.$store.state.lazyComponent 
            && this.$store.state.lazyComponent.components['login-modal'];
          
          if (isComponentLoaded || document.querySelector('#login .tab-pane#tab1 login')) {
            // Event-Listener für Modal-Close, um Scrollen zu verhindern
            window.$('#login').one('hidden.bs.modal', function() {
              // Stelle die Scroll-Position wieder her
              window.scrollTo(0, scrollY);
            });
            
            // Verwende Bootstrap's native Event-System
            window.$('#login').modal('show');
          } else {
            // Komponente noch nicht geladen, warte noch etwas
            setTimeout(checkAndOpenModal, 100);
          }
        }
      };
      
      setTimeout(checkAndOpenModal, 150);
    },
    
    // Property 87: Durchschnittliche Wahrscheinlichkeit (für Rumor Probability Widget)
    averageProbabilityFromProperty() {
      if (this.currentVariation?.variationProperties) {
        for (let property of this.currentVariation.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 87);
            if (result?.values) {
              const value = parseFloat(result.values.value);
              return !isNaN(value) ? value : null;
            }
          }
        }
      }
      return null;
    },
    
    // Property 95: Anzahl der Votes (für Rumor Probability Widget)
    probabilityCountFromProperty() {
      if (this.currentVariation?.variationProperties) {
        for (let property of this.currentVariation.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 95);
            if (result?.values) {
              const value = parseInt(result.values.value, 10);
              return !isNaN(value) ? value : null;
            }
          }
        }
      }
      return null;
    },
    
    // Property 96: SofaScore Widget Code
    getSofaScoreWidget() {
      if (this.currentVariation?.variationProperties) {
        for (let property of this.currentVariation.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 96);
            if (result?.values?.value) {
              return result.values.value.trim();
            }
          }
        }
      }
      return null;
    },
  },
};
</script>

